import { getPortalId } from '../../../utils/getPortalId';
import { Metrics } from '../../../utils/metrics';
import { dataFetchingErrorHandler } from '../../../errors/dataFetchingErrorHandler';
import { isActiveTrialsCacheStale, activeTrialsCache } from '../utils/trialUtils';
import { getActiveHubTrials as fetchActiveTrials } from './hubTrialsApi';
import { delay } from '../../../utils/delay';
export const REVALIDATE_AFTER = 5000;
const errorHandler = dataFetchingErrorHandler('Failed to fetch active trials');
const onFetchError = err => {
  if (err.status !== 401) {
    Metrics.counter('GET_ACTIVE_TRIALS_FAILURE').increment();
    errorHandler(err);
  }
};
export const getCachedActiveTrials = async () => {
  const portalId = getPortalId();
  const cachedTrials = portalId ? activeTrialsCache.get(portalId) : null;
  const isCachedDataStale = cachedTrials ? isActiveTrialsCacheStale(cachedTrials) : null;
  const storeResponse = trials => {
    if (trials && portalId) {
      activeTrialsCache.set(portalId, trials);
    }
  };
  if (cachedTrials && !isCachedDataStale) {
    delay(REVALIDATE_AFTER).then(fetchActiveTrials).then(storeResponse).catch(onFetchError);
    return cachedTrials.trials;
  } else {
    try {
      const trials = await fetchActiveTrials();
      storeResponse(trials);
      return trials || [];
    } catch (error) {
      onFetchError(error);
      return [];
    }
  }
};
export const refreshActiveTrialsCache = () => {
  const portalId = getPortalId();
  if (portalId) {
    activeTrialsCache.delete(portalId);
  }
  return fetchActiveTrials();
};